import React from 'react';
import styled from 'styled-components'
import checkedIcon from '../../resources/icons/checkbox-checked.png';
import uncheckedIcon from "../../resources/icons/checkbox-blank.png"

export const Check = styled.div`
    margin: auto;
    height: 22px;
    width: 22px;
    background: ${props => props.checked ? 
                `url(${checkedIcon}) center center no-repeat;` :
                `url(${uncheckedIcon}) center center no-repeat;`}
`